import { Typography, TypographyTypeMap } from '@mui/material';

export const SectionTitle = ({ title, marginTop = 2, marginBottom = 1, variant = 'h3', color, fontWeight }: { title: string; marginTop?: number; marginBottom?: number; variant?: string; color?: string; fontWeight?: number }) => {

  return (
    <Typography 
      variant={variant as TypographyTypeMap['props']['variant']}
      color={color}
      fontWeight={fontWeight}
      marginBottom={marginBottom} 
      marginTop={marginTop}
    >
      {title}
    </Typography>
  );
};
